import React, { useEffect } from "react";
import { LegalShell, Section } from "./LegalShell";

export default function DatenschutzPage() {
  useEffect(() => {
    document.title = "Plantus · Datenschutzerklärung";
  }, []);
  return (
    <LegalShell title="Datenschutzerklärung" lastUpdated="Februar 2026" testId="datenschutz-page">
      <Section title="1. Verantwortlicher">
        <p>
          Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:
          <br />
          <br />
          <strong>Hoytec-Solutions</strong>, Inhaber René Hoyer
          <br />
          Neusornziger Straße 9, 04769 Mügeln
          <br />
          E-Mail: <a href="mailto:info@plantus-app.com" className="text-forest-700 hover:underline">info@plantus-app.com</a>
          <br />
          Telefon: +49 173 5993152
        </p>
      </Section>

      <Section title="2. Allgemeines zur Datenverarbeitung">
        <p>
          Wir verarbeiten personenbezogene Daten der Nutzer grundsätzlich nur, soweit dies zur
          Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen
          erforderlich ist. Die Verarbeitung erfolgt regelmäßig nur nach Einwilligung des Nutzers
          oder soweit die Verarbeitung durch gesetzliche Vorschriften gestattet ist.
        </p>
        <p>
          Rechtsgrundlagen für die Verarbeitung sind je nach Fall: Art. 6 Abs. 1 lit. a DSGVO
          (Einwilligung), lit. b (Vertrag), lit. c (rechtliche Verpflichtung), lit. f (berechtigtes
          Interesse).
        </p>
      </Section>

      <Section title="3. Bereitstellung der Website und Server-Logfiles">
        <p>
          Bei jedem Aufruf unserer Website erfasst unser System automatisiert Daten und
          Informationen vom Computersystem des aufrufenden Rechners (IP-Adresse, Datum, Uhrzeit,
          Browser, Betriebssystem). Die Speicherung erfolgt aus Sicherheitsgründen und zur
          Gewährleistung eines stabilen Betriebs (Art. 6 Abs. 1 lit. f DSGVO). Die Daten werden
          spätestens nach 30 Tagen gelöscht.
        </p>
      </Section>

      <Section title="4. Nutzerkonto und PSM-Dokumentation">
        <p>
          Zur Nutzung von Plantus ist die Erstellung eines Nutzerkontos erforderlich. Hierbei
          verarbeiten wir:
        </p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Name, E-Mail-Adresse, Passwort (gehasht), Betriebsname</li>
          <li>Optional: Branche, Sachkundenachweis-Nummer</li>
          <li>Eingegebene Flächendaten (Bezeichnung, Größe, Kultur, ggf. GPS-Koordinaten)</li>
          <li>Eingegebene Pflanzenschutzmittel-Anwendungen (Mittel, Menge, Wartezeit, Wetter, Datum, Uhrzeit, GPS, Anwender, etc.)</li>
        </ul>
        <p>
          Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) und Art. 6 Abs. 1 lit. c
          DSGVO (rechtliche Verpflichtung nach § 11 PflSchG und EU 2023/564). Die Speicherung
          erfolgt mindestens 3 Jahre nach Eintrag der jeweiligen Anwendung, danach erfolgt die
          Löschung auf Anfrage.
        </p>
      </Section>

      <Section title="5. Zahlungsabwicklung über Stripe">
        <p>
          Bei Abschluss eines kostenpflichtigen Abos werden die Zahlungsdaten direkt durch die
          Stripe Payments Europe, Ltd., 1 Grand Canal Street Lower, Grand Canal Dock, Dublin,
          Irland verarbeitet. Wir erhalten lediglich eine Bestätigung der Zahlung, keine
          Zahlungsmittel-Details. Datenschutz von Stripe:{" "}
          <a
            href="https://stripe.com/de/privacy"
            target="_blank"
            rel="noreferrer"
            className="text-forest-700 hover:underline"
          >
            stripe.com/de/privacy
          </a>
          . Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
        </p>
      </Section>

      <Section title="6. KI-gestützte Auswertung (OCR und Excel-Import)">
        <p>
          Für die Foto-Erkennung handschriftlicher Spritztagebücher und die KI-gestützte
          Zuordnung von Excel-Spalten setzen wir Modelle der Anbieter OpenAI Ireland Ltd. und
          Google Ireland Ltd. ein. Die Daten werden ausschließlich zur Verarbeitung des
          jeweiligen Vorgangs übermittelt, nicht zu Trainingszwecken verwendet und nach kurzer
          Zeit gelöscht. Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO.
        </p>
      </Section>

      <Section title="7. Hosting und Auftragsverarbeitung">
        <p>
          Die Website und Datenbank wird gehostet bei Emergent (Emergent Labs Inc.). Mit dem
          Anbieter besteht ein Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO. Der Server-Standort
          ist innerhalb der EU.
        </p>
      </Section>

      <Section title="8. Anbindung an die offizielle BVL-Datenbank">
        <p>
          Zur Plausibilisierung der eingegebenen Pflanzenschutzmittel synchronisieren wir
          regelmäßig die Daten aus der öffentlich zugänglichen Datenbank des Bundesamtes für
          Verbraucherschutz und Lebensmittelsicherheit (BVL). Es werden hierbei keine
          personenbezogenen Daten an das BVL übermittelt.
        </p>
      </Section>

      <Section title="9. Ihre Rechte">
        <p>Sie haben jederzeit das Recht auf:</p>
        <ul className="list-disc pl-5 space-y-1">
          <li>Auskunft (Art. 15 DSGVO)</li>
          <li>Berichtigung (Art. 16 DSGVO)</li>
          <li>Löschung (Art. 17 DSGVO, soweit nicht gesetzliche Aufbewahrungsfristen entgegenstehen)</li>
          <li>Einschränkung der Verarbeitung (Art. 18 DSGVO)</li>
          <li>Datenübertragbarkeit (Art. 20 DSGVO)</li>
          <li>Widerspruch (Art. 21 DSGVO)</li>
          <li>Widerruf einer erteilten Einwilligung (Art. 7 Abs. 3 DSGVO)</li>
          <li>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO)</li>
        </ul>
        <p>
          Zur Ausübung Ihrer Rechte genügt eine formlose E-Mail an{" "}
          <a href="mailto:info@plantus-app.com" className="text-forest-700 hover:underline">
            info@plantus-app.com
          </a>
          .
        </p>
      </Section>

      <Section title="10. Cookies und lokale Speicherung">
        <p>
          Wir verwenden technisch notwendige Cookies und Local-Storage, um Sie nach dem Login
          eingeloggt zu halten (JWT-Token). Es findet kein Tracking durch Dritte statt. Eine
          Einwilligung ist hierfür nicht erforderlich (§ 25 Abs. 2 TTDSG).
        </p>
      </Section>

      <Section title="11. Änderungen dieser Datenschutzerklärung">
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, soweit dies durch
          rechtliche Änderungen oder Anpassungen unserer Dienste erforderlich wird. Es gilt jeweils
          die aktuell auf dieser Seite veröffentlichte Fassung.
        </p>
      </Section>
    </LegalShell>
  );
}
